module.exports = __webpack_public_path__ + "static/img/4en.fb83e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/4en.png
// module id = sWIZ
// module chunks = 0